module.exports = require("./lib/install")(Infinity);